const _ = window._; // TODO: Replace with import once all services are being imported instead of using window.cirkulServices
const $ = window.$; // TEMPORARY. REMOVE JQUERY WHEN POSSIBLE.

console.log('[2024-10-14] subscriptions init');

// TODO: Remove IIFE, export hook that returns reactive state and callable functions.
(() => {

  const SUBSCRIPTION_MANAGEMENT_API_LOCATION = '/apps/subscription-management';
  const SESSION_CHECK_ERROR_LOCAL_VARIABLE = 'cirkul::check::error'
  const SERVER_TIMEOUT_STATUS_CODE = 503;

  const SHIPPING_RATE_TITLES = {
    EXPEDITED_SHIPPING: 'Expedited Shipping',
    STANDARD_SHIPPING: 'Standard Shipping',
  };

  window.cirkulServices = window.cirkulServices || {};
  window.cirkulServices.subscriptions = {
    SHIPPING_RATE_TITLES: SHIPPING_RATE_TITLES,
    check: check,
    hasSubscription: hasSubscription,
    getData: getData,
    getDataForceNew: getDataForceNew,
    setDiscountCode: setDiscountCode,
    setPaymentCard: setPaymentCard,
    sendPaymentCardUpdateEmail: sendPaymentCardUpdateEmail,
    createAddon: createAddon,
    removeAddon: removeAddon,
    setExtraSip: setExtraSip,
    setShippingAddress: setShippingAddress,
    setEmail: setEmail,
    rescheduleSubscription: rescheduleSubscription,
    resumeSubscription: resumeSubscription,
    cancelSubscription: cancelSubscription,
    cancelSave: cancelSave,
    applyPromoOffer: applyPromoOffer,
    updateSubscriptionPlan: updateSubscriptionPlan,
    shipNow: shipNow,
    setShippingRate: setShippingRate,
    setUsedReactivateIncentive: setUsedReactivateIncentive,
  };
  window.resolveCirkulServices.subscriptions();


  function check(email, action) {
    const cachedErrorString = sessionStorage.getItem(SESSION_CHECK_ERROR_LOCAL_VARIABLE);

    console.log('MARCTEST CACHED ERROR', cachedErrorString, typeof cachedErrorString);

    if (typeof cachedErrorString === 'string') {
      return Promise.resolve({ error: cachedErrorString === 'true' });
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/check`,
        data: {
          email: email,
          action: action
        },
      }).done((response) => {
        sessionStorage.setItem(SESSION_CHECK_ERROR_LOCAL_VARIABLE, response.error);

        resolve({ error: response.error });
      }).fail((error) => {
        sessionStorage.setItem(SESSION_CHECK_ERROR_LOCAL_VARIABLE, false);

        resolve({ error: false }); // Fail-safe if service couldn't be reached.
      });
    });
  }

  function hasSubscription(shopifyCustomerId) {
    let hasSubscriptionData = false;

    if (!shopifyCustomerId) {
      return Promise.resolve(hasSubscriptionData);
    }

    return Promise.resolve()
      .then(confirmHasSubscriptionData)
      .then(() => {
        return hasSubscriptionData;
      });

    function confirmHasSubscriptionData() {
      let rechargeCustomerHash = sessionStorage.getItem(`cirkul:subscription-hash-for-id:${shopifyCustomerId}`);

      if (rechargeCustomerHash) {
        hasSubscriptionData = true;

        return Promise.resolve(); // If we've previously gotten a hash for this ID, we know it has data.
      }

      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'get',
          url: `/tools/recurring/get_rc_token/${shopifyCustomerId}`,
        }).done((response) => {
          const rechargeCustomer = JSON.parse(response.match(/{"rc_customer":.*}}/g)[0]).rc_customer;
          hasSubscriptionData = !!rechargeCustomer.token;

          resolve();
        }).fail((err) => {
          resolve();
        });
      });
    }
  }

  function getData(shopifyCustomerId, suppressAlert) {
    let attemptNumber = 0;
    let hasSubscriptionData = false;

    if (!shopifyCustomerId) {
      return Promise.reject({ status: 404, message: `No subscription data found for customer ${shopifyCustomerId}` });
    }

    return Promise.resolve()
      .then(confirmHasSubscriptionData)
      .then(attemptGetData);

    function confirmHasSubscriptionData() {
      let rechargeCustomerHash = sessionStorage.getItem(`cirkul:subscription-hash-for-id:${shopifyCustomerId}`);

      if (rechargeCustomerHash) {
        hasSubscriptionData = true;
        return Promise.resolve(); // If we've previously gotten a hash for this ID, we know it has data.
      }

      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'get',
          url: `/tools/recurring/get_rc_token/${shopifyCustomerId}`,
        }).done((response) => {
          const rechargeCustomer = JSON.parse(response.match(/{"rc_customer":.*}}/g)[0]).rc_customer;
          hasSubscriptionData = !!rechargeCustomer.token;

          resolve();
        }).fail((err) => {
          if (err.status === 500) {
            reject(err);
          } else {
            resolve();
          }
        });
      });
    }

    function attemptGetData(suppressError, reportError) {
      attemptNumber++;

      if (!hasSubscriptionData) {
        return Promise.resolve({});
      }

      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'get',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/shopify/${shopifyCustomerId}`,
          data: {
            retry: !!suppressError,
            convert: true,
            convertExpedited: true,
            convertRebranded: true,
            reportError: !!reportError,
          },
        }).done(resolve)
          .fail((error) => {
            if (attemptNumber === 1) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 5000);
            } else if (attemptNumber === 2) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 10000);
            } else if (attemptNumber === 3) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 15000);
            } else if (attemptNumber === 4) {
              setTimeout(() => {
                resolve(attemptGetData(true, true));
              }, 30000);
            } else if (attemptNumber === 5) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 5000);
            } else if (attemptNumber === 6) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 10000);
            } else if (attemptNumber === 7) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 15000);
            } else {
              console.log('MARCTEST READ SUBSCRIPTION DATA ERROR', error);
              if (!suppressAlert) {
                alert(`We're having some trouble retrieving your latest subscription information. Please check back later, or contact help@drinkcirkul.com if the problem continues.`);
              }
              reject({});
            }
          });
      });
    }
  }

  function getDataForceNew(shopifyCustomerId, suppressAlert) {
    let attemptNumber = 0;
    let hasSubscriptionData = false;

    if (!shopifyCustomerId) {
      return Promise.reject({ statusCode: 404, message: `No subscription data found for customer ${shopifyCustomerId}` });
    }

    return Promise.resolve()
      .then(confirmHasSubscriptionData)
      .then(attemptGetData);

    function confirmHasSubscriptionData() {
      let rechargeCustomerHash = sessionStorage.getItem(`cirkul:subscription-hash-for-id:${shopifyCustomerId}`);

      if (rechargeCustomerHash) {
        hasSubscriptionData = true;
        return Promise.resolve(); // If we've previously gotten a hash for this ID, we know it has data.
      }

      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'get',
          url: `/tools/recurring/get_rc_token/${shopifyCustomerId}`,
        }).done((response) => {
          const rechargeCustomer = JSON.parse(response.match(/{"rc_customer":.*}}/g)[0]).rc_customer;
          hasSubscriptionData = !!rechargeCustomer.token;

          resolve();
        }).fail(() => {
          resolve();
        });
      });
    }

    function attemptGetData(suppressError, reportError) {
      attemptNumber++;

      if (!hasSubscriptionData) {
        return Promise.resolve({});
      }

      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'get',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/shopify/${shopifyCustomerId}`,
          data: {
            new: true,
            retry: !!suppressError,
            convert: true,
            convertExpedited: true,
            convertRebranded: true,
            reportError: !!reportError,
          },
        }).done(resolve)
          .fail((error) => {
            if (attemptNumber === 1) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 5000);
            } else if (attemptNumber === 2) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 10000);
            } else if (attemptNumber === 3) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 15000);
            } else if (attemptNumber === 4) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 30000);
            } else if (attemptNumber === 5) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 5000);
            } else if (attemptNumber === 6) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 10000);
            } else if (attemptNumber === 7) {
              setTimeout(() => {
                resolve(attemptGetData(true));
              }, 15000);
            } else {
              console.log('MARCTEST READ SUBSCRIPTION DATA ERROR', error);
              reject({ message: 'TODO: ERROR MESSAGE' });
            }
          });
      });
    }
  }

  function setDiscountCode(shopifyCustomerId, newDiscountCode) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            discountCode: newDiscountCode
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/set-discount-code`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function setPaymentCard(shopifyCustomerId, braintreeNonce) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            cardToken: braintreeNonce
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/update-card`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function sendPaymentCardUpdateEmail(shopifyCustomerId) {
    return getData(shopifyCustomerId).then((subscriptionData) => {
      const rechargeCustomerHash = subscriptionData.subscription.rechargeCustomerHash;
      const rechargeAddressId = subscriptionData.subscription.rechargeAddressId;
      let themeEnginePortalToken = null;

      return Promise.resolve()
        .then(_getRechargePortalToken)
        .then(_sendEmail)
        ;

      function _getRechargePortalToken() {
        return new Promise((resolve, reject) => {
          $.ajax({
            type: 'get',
            url: `/tools/recurring/get_rc_token/${shopifyCustomerId}`,
          }).done((response) => {
            const rechargeCustomer = JSON.parse(response.match(/{"rc_customer":.*}}/g)[0]).rc_customer;
            themeEnginePortalToken = rechargeCustomer.token;

            resolve();
          }).fail((err) => {
            if (err.status === 500) {
              reject(err);
            } else {
              resolve();
            }
          });
        });
      }

      function _sendEmail() {
        return new Promise((resolve, reject) => {
          $.ajax({
            type: 'POST',
            url: `/tools/recurring/portal/${rechargeCustomerHash}/notifications?token=${themeEnginePortalToken}`,
            data: {
              template_type: 'shopify_update_payment_information',
              type: 'email',
              address_id: rechargeAddressId
            },
          }).done((response) => {
            resolve();
          }).fail(reject);
        });
      }
    });
  }

  function createAddon(shopifyCustomerId, properties) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify(properties),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/create-addon`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function removeAddon(shopifyCustomerId, lineItemId) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'DELETE',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/line-items/${lineItemId}`,
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function setExtraSip(shopifyCustomerId, variantId) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            variantId: variantId
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/set-extra-sip`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function setShippingAddress(shopifyCustomerId, properties) {
    properties.updateShippingRate = true;

    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify(properties),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/set-shipping-address`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function setEmail(shopifyCustomerId, newEmail) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            email: newEmail
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/set-email`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function rescheduleSubscription(shopifyCustomerId, nextShipmentDateString) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            nextShipmentDateString: nextShipmentDateString
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/reschedule-next-shipment`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function resumeSubscription(shopifyCustomerId, properties) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify(properties),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/resume-subscription`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function cancelSubscription(shopifyCustomerId) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/cancel-subscription`,
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function cancelSave(shopifyCustomerId, saveType, properties) {
    properties = properties || {};
    properties.saveType = saveType;
    properties.singleSips = true;

    console.log(`TJN PROPERTIES`, properties);

    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify(properties),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/apply-cancel-save`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }


  function applyPromoOffer(shopifyCustomerId, promoOffer, properties) {
    properties = properties || {};
    properties.promoOffer = promoOffer;

    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify(properties),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/apply-promo-offer`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function updateSubscriptionPlan(shopifyCustomerId, newPlanVariantId, newSips) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            newPlanVariantId: newPlanVariantId,
            newSips: newSips,
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/update-subscription-plan`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function shipNow(shopifyCustomerId, isCancelSave, attemptNumber, addonToCreate) {
    attemptNumber = attemptNumber || 1;

    if (addonToCreate) {
      return createAddon(shopifyCustomerId, addonToCreate)
        .then(() => {
          return _getRechargeCustomerHash(shopifyCustomerId);
        }).then(_shipNow);
    } else {
      return _getRechargeCustomerHash(shopifyCustomerId)
        .then(_shipNow);
    }

    function _shipNow(rechargeCustomerHash) {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            isCancelSave: !!isCancelSave
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/ship-now`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(() => {
          resolve(_checkShipNowStatus());
        }).fail((error) => {
          if (_.includes(error.responseText, 'Waiting On Push') && attemptNumber < 10) {
            setTimeout(() => {
              resolve(shipNow(shopifyCustomerId, isCancelSave, attemptNumber + 1));
            }, 5000);
          } else if (error.status === 0 || error.status === SERVER_TIMEOUT_STATUS_CODE) {
            // error.status is 0 if request timed out? Even though the response status code is 503.
            resolve(_checkShipNowStatus());
          } else {
            reject(error);
          }
        });
      });

      function _checkShipNowStatus() {
        return new Promise((resolve, reject) => {
          $.ajax({
            type: 'GET',
            url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/ship-now-status`,
          }).done((response) => {
            console.log('MARCTEST SHIP NOW RESPONSE', response);
            if (response.status === 'Success') {
              resolve();
            } else if (response.status === 'Processing') {
              setTimeout(() => {
                resolve(_checkShipNowStatus());
              }, 5000);
            } else {
              reject({ message: 'Payment Failed' });
            }
          }).fail(reject);
        });
      }
    }
  }

  function setShippingRate(shopifyCustomerId, shippingRateTitle) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          data: JSON.stringify({
            shippingRateTitle: shippingRateTitle,
          }),
          processData: false,
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/set-shipping-rate`,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function setUsedReactivateIncentive(shopifyCustomerId) {
    return _getRechargeCustomerHash(shopifyCustomerId).then((rechargeCustomerHash) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/${rechargeCustomerHash}/set-used-reactivate-incentive`,
        }).done(resolve)
          .fail(reject);
      });
    });
  }

  function _getRechargeCustomerHash(shopifyCustomerId) {
    return new Promise((resolve, reject) => {
      let rechargeCustomerHash = sessionStorage.getItem(`cirkul:subscription-hash-for-id:${shopifyCustomerId}`);

      if (rechargeCustomerHash) {
        resolve(rechargeCustomerHash);
        return;
      }

      $.ajax({
        type: 'GET',
        url: `${SUBSCRIPTION_MANAGEMENT_API_LOCATION}/customer/v2/shopify/${shopifyCustomerId}/hash`,
      }).done((response) => {
        rechargeCustomerHash = response.rechargeCustomerHash;

        sessionStorage.setItem(`cirkul:subscription-hash-for-id:${shopifyCustomerId}`, rechargeCustomerHash);

        resolve(rechargeCustomerHash);
      }).fail(reject);
    });
  }
})();
